/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Item_Children_ProgressInputs */

const en_item_children_progress = /** @type {(inputs: Item_Children_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} done`)
};

const de_item_children_progress = /** @type {(inputs: Item_Children_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.total} erledigt`)
};

/**
* | output |
* | --- |
* | "{done} of {total} done" |
*
* @param {Item_Children_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const item_children_progress = /** @type {((inputs: Item_Children_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Children_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_item_children_progress(inputs)
	return en_item_children_progress(inputs)
});